export const UnAuthorized = 'unauthorized';
